import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { Row, Card, Form, Input, Typography, Button, message } from 'antd';
import logo from '../../images/loginLogo.svg';

const { Title, Text, Link } = Typography;

interface IProps {
  authState?: any;
  onStateChange?: any;
}

const ForgotPassword: React.FC<IProps> = (props: IProps) => {
  const { authState, onStateChange } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  /*
   * When the form passes client side validation, we change state
   * to forgotPasswordReset and pass along the username through
   * the authData.
   *
   * On any error, we reset the form fields, set the loading state
   * to false and display the error message to the user.
   */

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      await Auth.forgotPassword(values.username);
      setLoading(false);
      onStateChange('forgotPasswordReset', values.username);
    } catch (e) {
      form.resetFields();
      setLoading(false);
      message.error(e.message);
    }
  };

  const onLinkClick = () => {
    onStateChange('signIn');
  };

  return authState === 'forgotPassword' ? (
    <Row justify="center" align="middle" className="Authenticator-page">
      <Card className="Authenticator-card Authenticator-card-fade-in">
        <img src={logo} alt="ehe-logo" className="Authenticator-logo" />
        <Form form={form} size="large" onFinish={onFinish}>
          <Row>
            <Text>
              Enter your username or email and a reset password code will be
              sent to you.
            </Text>
          </Row>
          <Title level={4} className="Authenticator-margin-top">
            Username or Email:
          </Title>
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: 'Please enter username or email!',
              },
            ]}
          >
            <Input placeholder="Enter Your Username Or Email..." />
          </Form.Item>
          <Row justify="center" className="Authenticator-margin-top">
            <Button type="primary" htmlType="submit" loading={loading}>
              Reset Password
            </Button>
          </Row>
          <Row justify="center" className="Authenticator-margin-top">
            <Link onClick={onLinkClick}>Back to Sign In</Link>
          </Row>
        </Form>
      </Card>
    </Row>
  ) : null;
};

export default ForgotPassword;
